export const routes = [
  // {
  //   path: '/cidade/:id/diagnostic/selo',
  //   component: () => import('./components/List'),
  //   name: 'city.diagnostico.selo',
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  {
    path: '/diagnostic/selo/download/:evidenceId',
    component: () => import('./components/DownloadImagensSelo'),
    name: 'diagnostico.selo.download',
  },
]
